import React from "react";
import bbLogo from "../../Blackbird_Logo.png";
import UserMenu from "./UserMenu";
import PatientContextChip from "../blueprint/PatientContextChip";

interface StandaloneHeaderProps {
  email: string;
  /** The active patient id, so the patient search/switch chip stays scoped. */
  patientId: string;
  onBack: () => void;
  onLogout: () => void;
}

/**
 * The per-patient app-shell header, rendered once above the tab strip so it
 * (and the patient search/switch chip it hosts) stays present across every
 * tab (BLA-334) — a tab switch never unmounts this component.
 */
const StandaloneHeader: React.FC<StandaloneHeaderProps> = ({
  email,
  patientId,
  onBack,
  onLogout,
}) => {
  return (
    <header className="relative z-40 bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between gap-4">
      <div className="flex items-center gap-6 shrink-0">
        <div className="flex items-center gap-3">
          <img
            src={bbLogo}
            alt="Blackbird Health"
            className="h-8 object-contain"
          />
          <h1 className="text-xl font-semibold text-gray-800">
            Precision Care Platform
          </h1>
        </div>

        <button
          onClick={onBack}
          aria-label="Back to Home"
          className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-1"
        >
          <span aria-hidden="true">←</span>
          {/* Hidden below `lg`: the patient search this header now also hosts
           * (BLA-334) needs the room on a narrow viewport; the icon + the
           * button's aria-label keep the control identifiable either way. */}
          <span className="hidden lg:inline">Back to Home</span>
        </button>
      </div>

      <PatientContextChip patientId={patientId} />

      <UserMenu email={email} onLogout={onLogout} />
    </header>
  );
};

export default StandaloneHeader;
